import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { exportVariable, persistor, store } from "./persist";
import Root from "./root";
import * as serviceWorker from "./serviceWorker";
import { handleFirebase } from "./utils/handerRoot";

require("dotenv").config();
handleFirebase();
exportVariable();

ReactDOM.render(
  <Provider store={store}>
    {/* PersistGate lưu giá trị state sau khi load f5 page  */}
    <PersistGate loading={<LoadableLoading />} persistor={persistor}>
      {/* sử dụng history lưu lịch sử và di chuyển giửa các router   */}
      <Root />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
